import { defineAsyncComponent } from 'vue'

const User = defineAsyncComponent(() => import('./user.vue'))
const UsersSelect = defineAsyncComponent(() => import('./users-select.vue'))

export { User, UsersSelect }
